import React, { useContext, useState } from 'react';
import { MultiPortfolioReviewContext } from '../common/MultiPortfolioReviewContext';
import { Warning } from 'venn-ui-kit';
import { hasNegativePosition, useShouldUseNetAssetsInsteadOfAllocation } from '../../../../../hooks/leverageAndShort';

export const DO_CASH_POSITIONS_NEED_REMAPPING_MESSAGE =
  'Does this portfolio contain cash positions? Please designate negative cash positions as cash borrowing and positive cash positions as cash holding via the ••• menu.';

export const FooterErrorBanner = () => {
  const {
    data: { parsedResults, selectedIndex },
  } = useContext(MultiPortfolioReviewContext);
  const [show, setshow] = useState(true);
  const shouldUseNetAssetsInsteadOfAllocation = useShouldUseNetAssetsInsteadOfAllocation();
  const openedPortfolio = parsedResults[selectedIndex]!.parsedPortfolio;
  const hasNegativePositions = hasNegativePosition(shouldUseNetAssetsInsteadOfAllocation)(openedPortfolio);
  if (!hasNegativePositions || !show) {
    return null;
  }

  return (
    <Warning
      icon="exclamation-circle"
      text={DO_CASH_POSITIONS_NEED_REMAPPING_MESSAGE}
      large
      dismissable
      onClick={() => setshow(false)}
    />
  );
};
